import { breakpointType, MenuSwitcherLinkModel } from '@lerna-core';

export const getAppSwitcherBreakpoint = (
  links: MenuSwitcherLinkModel[]
): keyof typeof breakpointType | undefined =>
  links.length > 2 ? 'mediumDown' : undefined;
